import { noop } from 'utility-belt/utilityFunctions';
import { ContractAction, ContractActions } from '../types';
import { useCommonValidation, COMMON_VALIDATION_ERRORS } from '../hooks/useCommonValidation';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useMemo } from 'react';
import { events } from '../../../event-tracking';
import { isActionUnavailable } from '../utils/utilities';
import { useAllowedActions } from '../hooks/useAllowedActions';
import { hasM3Gate } from '../../../utils/gates';
const PRIMARY_LABEL = 'commerceContractLib.actions.CREATE_RENEWAL_QUOTE.label';
const RenewalValidationMessages = Object.freeze({
  [COMMON_VALIDATION_ERRORS.unauthorized]: 'commerceContractLib.actions.CREATE_RENEWAL_QUOTE.errors.unauthorized',
  [COMMON_VALIDATION_ERRORS.jitaUser]: 'commerceContractLib.actions.CREATE_RENEWAL_QUOTE.errors.jitaUser'
  // TODO: Add when RPC validation is implemented
  // terminationScheduled: 'commerceContractLib.actions.CREATE_RENEWAL_QUOTE.errors.terminationScheduled',
  // contractTerminated: 'commerceContractLib.actions.CREATE_RENEWAL_QUOTE.errors.contractTerminated',
});
export const useRenewalAction = ({
  objectId,
  objectTypeId,
  skip
}) => {
  const {
    data
  } = useAllowedActions({
    objectId,
    objectTypeId
  }, {
    skip
  });
  const commonValidation = useCommonValidation({
    objectId,
    objectTypeId,
    skip
  });
  const sendOpenContractRenewalModal = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_CONTRACT_RENEWAL_QUOTE_MODAL);
  return useMemo(() => {
    var _data$actionStatuses, _actionStatuses$find;
    const actionStatuses = (_data$actionStatuses = data === null || data === void 0 ? void 0 : data.actionStatuses) !== null && _data$actionStatuses !== void 0 ? _data$actionStatuses : [];
    const isUnavailable = isActionUnavailable({
      objectId,
      objectTypeId,
      skip
    }) || !hasM3Gate() || ((_actionStatuses$find = actionStatuses.find(status => status.action === ContractActions.CREATE_RENEWAL_QUOTE)) === null || _actionStatuses$find === void 0 ? void 0 : _actionStatuses$find.enabled) !== true;
    if (isUnavailable) {
      return ContractAction.unavailable();
    }

    // TODO: Check for terminationScheduled validation from RPC
    // TODO: Check for contractTerminated validation from RPC

    if (commonValidation) {
      return ContractAction.invalid({
        validationMessageKey: RenewalValidationMessages[commonValidation],
        messageKey: PRIMARY_LABEL,
        onClick: noop
      });
    }
    return ContractAction.ok({
      messageKey: PRIMARY_LABEL,
      onClick: () => {
        events.CREATE_RENEWAL_QUOTE.open();
        sendOpenContractRenewalModal({
          contractId: objectId
        });
      }
    });
  }, [objectTypeId, data === null || data === void 0 ? void 0 : data.actionStatuses, commonValidation, sendOpenContractRenewalModal, objectId, skip]);
};